import { render } from "./pause.svg?vue&type=template&id=0854efd2"
const script = {}
script.render = render

export default script